if (!customElements.get("collection-read-more")) {
  class CollectionReadMore extends HTMLElement {
    connectedCallback() {
      this.preview = this.querySelector(
        "[data-collection-read-more-preview]"
      );

      this.fullContent = this.querySelector(
        "[data-collection-read-more-full]"
      );

      this.button = this.querySelector(
        "[data-collection-read-more-toggle]"
      );

      this.label = this.querySelector(
        "[data-collection-read-more-label]"
      );

      if (
        !this.preview ||
        !this.fullContent ||
        !this.button
      ) {
        return;
      }

      this.handleClick = this.toggle.bind(this);

      this.button.addEventListener(
        "click",
        this.handleClick
      );

      if (this.dataset.startExpanded === "true") {
        this.setState(true);
      }
    }

    disconnectedCallback() {
      if (this.button && this.handleClick) {
        this.button.removeEventListener(
          "click",
          this.handleClick
        );
      }
    }

    toggle() {
      const isExpanded =
        this.button.getAttribute("aria-expanded") === "true";

      this.setState(!isExpanded);
    }

    setState(expanded) {
      this.button.setAttribute(
        "aria-expanded",
        expanded
      );

      this.preview.hidden = expanded;

      this.fullContent.classList.toggle(
        "is-visible",
        expanded
      );

      this.label.textContent = expanded
        ? this.label.dataset.lessText
        : this.label.dataset.moreText;
    }
  }

  customElements.define(
    "collection-read-more",
    CollectionReadMore
  );
}